import { render, staticRenderFns } from "./home-sa.vue?vue&type=template&id=136675d7&"
import script from "./home-sa.vue?vue&type=script&lang=js&"
export * from "./home-sa.vue?vue&type=script&lang=js&"
import style0 from "./home-sa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports